import React, { useEffect, useState } from "react";
import { Field, Form, Button, Link } from "@bwevents/components";
import SocialLogin from "../components/SocialLogin";
import InputPassword from "../components/InputPassword";
import { Validations } from "../services/Validations";
import { useNavigate } from "react-router-dom";
import { Loading } from "../common/pages";
import "./Register.scss";

export default function Register({ api, messenger, setAccount }) {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [timeRedirect, setTimeRedirect] = useState(5);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState();
  const [passwordConfirmValid, setPasswordConfirmValid] = useState(false);
  const [acceptEmails, setAcceptEmails] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const [submitted, setSubmitted] = useState(false);

  const firstNameValid = firstName !== "" ? Validations.isName(firstName) : "";
  const lastNameValid = lastName !== "" ? Validations.isName(lastName) : "";
  const emailValid = email !== "" ? Validations.isEmail(email) : "";
  const formValidStep1 = firstName && lastName && email;
  const formValidStep2 = passwordValid && passwordConfirmValid && acceptTerms;

  const getPassword = (e) => {
    setPassword(e);
  };
  const passwordIsValid = (e) => {
    setPasswordValid(e);
  };

  const getPasswordConfirm = (e) => {
    setPasswordConfirm(e);
  };
  const passwordConfirmIsValid = (e) => {
    setPasswordConfirmValid(e);
  };

  const fieldsStep1 = () => {
    return (
      <>
        <div className="bw-event-row">
          <div className="bw-event-col">
            <Field
              type="text"
              label="First name"
              placeholder="First name"
              value={firstName}
              setValue={setFirstName}
              invalid={firstName === "" || firstNameValid === false}
              invalidMessage={
                (firstName === "" ? "First name is required." : "") ||
                (!firstNameValid ? "First name is invalid." : "")
              }
              className="bw-event-input"
            />
          </div>
          <div className="bw-event-col">
            <Field
              type="text"
              label="Last name"
              placeholder="Last name"
              value={lastName}
              setValue={setLastName}
              invalid={lastName === "" || lastNameValid === false}
              invalidMessage={
                (lastName === "" ? "Last name is required." : "") ||
                (!lastNameValid ? "Last name is invalid." : "")
              }
              className="bw-event-input"
            />
          </div>
        </div>
        <Field
          type="text"
          label="Email"
          placeholder="Email"
          value={email}
          setValue={setEmail}
          invalid={email === "" || emailValid === false}
          invalidMessage={
            (email === "" ? "Email is required." : "") ||
            (!emailValid ? "Email is invalid." : "")
          }
          className="bw-event-input"
        />
      </>
    );
  };
  const fieldsStep2 = () => {
    return (
      <>
        <InputPassword
          label="Password"
          placeholder="Enter password"
          emmitValue={getPassword}
          emmitValid={passwordIsValid}
        >
          <p className="bw-event-callout mb-3">
            6 to 20 symbols (A-Z, a-z, 0-9)
          </p>
        </InputPassword>
        <InputPassword
          label="Repeat password"
          placeholder="Enter password"
          equalTo={password}
          typeConfirm={true}
          forceInvalidConfirm={password !== passwordConfirm}
          emmitValue={getPasswordConfirm}
          emmitValid={passwordConfirmIsValid}
        />
        <Field
          className="bw-event-checkbox"
          type="checkbox"
          label="I agree to receive emails from BW Events about offers, events, products and services."
          value={acceptEmails}
          setValue={setAcceptEmails}
        />
        <div className="flex">
          <Field
            className="bw-event-checkbox mb-0"
            type="checkbox"
            label="I agree with BW Events"
            value={acceptTerms}
            setValue={setAcceptTerms}
          />
          <Link href="#" className="bw-event-link pl-1">
            Privacy Policy
          </Link>
        </div>
      </>
    );
  };

  const feedbackRegister = () => {
    messenger({
      severity: "success",
      detail: "Registration completed successfully.",
      life: 3000,
    });
  };
  const handleRegister = () => {
    setLoading(true);

    api("api/auth/register/", {
      method: "POST",
      ignoreError: true,
      body: {
        email: email,
        password,
        password_repeat: passwordConfirm,
        profile: {
          first_name: firstName,
          last_name: lastName,
          accept_newsletter: acceptEmails,
        },
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      },
    }).then(({ ok }) => {
      if (ok) {
        feedbackRegister();
        setSubmitted(true);
      } 
      
      setLoading(false);
    });
  };

  useEffect(() => {
    if (submitted) {
      let timeCount = 5;
      const countdownRedirect = setInterval(function () {
        if (timeCount < 0) {
          clearInterval(countdownRedirect);
          navigate("/");
        } else {
          setTimeRedirect(timeCount);
        }
        timeCount -= 1;
      }, 1000);
    }
  }, [submitted, navigate]);

  return (
    <div className={`register-page ${loading ? "loading" : ""}`}>
      {!loading ? (
        <div className="bw-event-container">
          {submitted ? (
            <>
              <div className="pt-5 mt-5 text-center">
                <h2 className="pt-5 pb-4 mt-5">
                  To complete your registration, click on the activation link
                  sent to your email.
                </h2>
                <p>
                  You will be sent back to the home page in {timeRedirect}{" "}
                  second
                  {timeRedirect > 0 ? "s" : ""}
                </p>
              </div>
            </>
          ) : (
            <>
              <h2>Sign up</h2>
              <Form className="mb-4">
                <div className="mobile">
                  {step < 2 ? (
                    <>
                      {fieldsStep1()}
                      <Button
                        className="mx-auto bw-event-btn btn-step"
                        label="Continue"
                        onClick={() => setStep(2)}
                        disabled={!formValidStep1}
                      />
                    </>
                  ) : (
                    <>
                      {fieldsStep2()}
                      <Button
                        className="mx-auto bw-event-btn btn-submit"
                        label="Sign Up"
                        onClick={handleRegister}
                        disabled={!formValidStep1 || !formValidStep2}
                      />
                    </>
                  )}
                </div>
                <div className="desktop">
                  {fieldsStep1()}
                  {fieldsStep2()}
                  <Button
                    className="mx-auto bw-event-btn"
                    label="Sign Up"
                    onClick={handleRegister}
                    disabled={!formValidStep1 || !formValidStep2}
                  />
                </div>
              </Form>
              <SocialLogin
                api={api}
                navigate={navigate}
                setLoading={setLoading}
                setAccount={setAccount}
              />
            </>
          )}
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
}
